import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/store";
import router from "@/router";

Vue.use(VueAxios, axios);

let logoutTimer = null;

function getTokenExpireTime(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000;
  } catch (e) {
    return null;
  }
}

async function forceLogout() {
  await Vue.prototype.$swal.fire({
    icon: "warning",
    title: "เซสชันหมดอายุ",
    text: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
  });

  store.dispatch("logout");
  router.replace({ name: "login" }).catch(() => {});
}

function setupAutoLogout() {
  const token = store.getters.getAccessToken;
  if (!token) return;

  const expTime = getTokenExpireTime(token);
  if (!expTime) return;

  const now = Date.now();
  const timeLeft = expTime - now;

  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }

  if (timeLeft <= 0) {
    forceLogout();
  } else {
    logoutTimer = setTimeout(() => {
      forceLogout();
    }, timeLeft);
  }
}

setupAutoLogout();

axios.interceptors.request.use((config) => {
  const token = store.getters.getAccessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (error.response && error.response.status === 401) {
      return forceLogout();
    }
    return Promise.reject(error);
  }
);

export default axios;
export { setupAutoLogout };
